/* Shared text-only segmentation: this does not parse or execute HTML/Markdown. */
(function(scope){
  function segments(value){
    const text=String(value||''),out=[];
    const fence=/^ {0,3}```([a-zA-Z0-9_+-]{0,24})[ \t]*\n([\s\S]*?)^ {0,3}```[ \t]*(?:\n|$)/gm;
    let cursor=0,match;
    while((match=fence.exec(text))){
      if(match.index>cursor)out.push({type:'text',text:text.slice(cursor,match.index)});
      out.push({type:'code',language:match[1].toLowerCase(),text:match[2].replace(/\n$/,'')});cursor=fence.lastIndex;
    }
    if(cursor<text.length)out.push({type:'text',text:text.slice(cursor)});
    return out;
  }
  function prose(value){return segments(value).filter(s=>s.type==='text').map(s=>s.text.replace(/`[^`\n]+`/g,'')).join('\n');}
  scope.RasmineAnswerFormat={segments,prose};
})(globalThis);
